import type { TagSheetAd, TagSheetParseResult } from '../../types';
import type { DropError } from '../../validation/validateDrop';
import { validateDrop } from '../../validation/validateDrop';
import { UNMAPPED_GROUP_ID } from '../constants';

export const validateLineItemToDrop = (
  parseResult: TagSheetParseResult,
  adId: string,
  lineItemId: string
): DropError | null => {
  if (lineItemId === UNMAPPED_GROUP_ID) return null;

  const allAds = [...parseResult.unmappedAds, ...parseResult.lineItems.flatMap((lineItem) => lineItem.tagSheetAds)];
  const ad = allAds.find(({ id }) => id === adId);

  if (!ad) return null;

  const targetLineItem = parseResult.lineItems.find((lineItem) => lineItem.id === lineItemId);

  if (!targetLineItem) return null;

  return validateDrop(ad, targetLineItem);
};

export const updateGroupAds = (
  prev: TagSheetParseResult | null,
  groupId: string,
  updatedAds: TagSheetAd[]
): TagSheetParseResult | null => {
  if (!prev) return prev;

  if (groupId === UNMAPPED_GROUP_ID) {
    return { ...prev, unmappedAds: updatedAds };
  }

  const lineItemIndex = prev.lineItems.findIndex((lineItem) => lineItem.id === groupId);

  if (lineItemIndex === -1) return prev;

  const updatedLineItems = [...prev.lineItems];

  updatedLineItems[lineItemIndex] = {
    ...updatedLineItems[lineItemIndex],
    tagSheetAds: updatedAds,
  };

  return { ...prev, lineItems: updatedLineItems };
};
